import { useTranslation } from 'react-i18next';
import useDimensions from '../../hook/useDimension';
import Histogram from '../Histogram/Histogram';
import './SurveyResultComponent.css';

function SurveyResultComponent(props) {

	const [ref, dimensions] = useDimensions();
	const { t } = useTranslation();

	return (
		<div className='survey-result-component'>
			<div className='survey-result-component__content'>
				<div className='content-element'>
					<div ref={ref} className='chart-histogram'>
						<Histogram
							width={props.histoWidth || dimensions.width}
							height={props.histoHeight || dimensions.height}
							buckets={props.histogramData}
							labels={props.histogramLabels}
							xTitle={t('result.histogram.axis-x')}
							yTitle={t('result.histogram.axis-y')}
							scores={[
								{
									name: `${props.enterprise?.name}\n(${(new Date(props.survey.completedAt)).toLocaleDateString()})`,
									value: props.survey?.globalScore
								},
								{
									name: `${props.enterpriseCompare?.name}\n(${(new Date(props.surveyCompare?.completedAt)).toLocaleDateString()})`,
									value: props.surveyCompare?.globalScore
								}
							]}
							mean={props.reference?.global?.Mean}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SurveyResultComponent;